/**
 * Detects hero KPI tiles generated by {@link mockSectionData} (draft placeholders).
 * Warehouse snapshots use title-case labels such as `Members Engaged`.
 * @param dataSnapshot - Hero section snapshot JSON.
 * @returns True when KPI tiles match mock generator labels.
 */
export const isMockHeroKpiSnapshot = (
  dataSnapshot: Record<string, unknown>,
): boolean => {
  const tiles = dataSnapshot.kpiTiles;
  if (!Array.isArray(tiles) || tiles.length === 0) {
    return false;
  }
  return tiles.some(tile => {
    if (!tile || typeof tile !== 'object') {
      return false;
    }
    const record = tile as { label?: string; value?: string; sub?: string };
    const label = record.label;
    const value = record.value ?? '';
    if (
      label === 'Engaged members' ||
      label === 'Engagement rate' ||
      label === 'Needs fulfilled' ||
      label === 'Satisfaction score'
    ) {
      return true;
    }
    if (
      typeof label === 'string' &&
      label.toLowerCase().includes('needs fulfilled') &&
      !value.includes('%')
    ) {
      return true;
    }
    return typeof record.sub !== 'string' || record.sub.length === 0;
  });
};
